import { render, staticRenderFns } from "./DashbordIndex.vue?vue&type=template&id=6a18e4be&scoped=true&"
import script from "./DashbordIndex.vue?vue&type=script&lang=js&"
export * from "./DashbordIndex.vue?vue&type=script&lang=js&"
import style0 from "./DashbordIndex.vue?vue&type=style&index=0&id=6a18e4be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a18e4be",
  null
  
)

export default component.exports